import { useState } from 'react'
import { useAddStaffMutation } from '@/core/services/staff'

export function useAddDoctor() {
  const [addDoctorDialogOpen, setAddDoctorDialogOpen] = useState(false)

  const [addDoctor, { isLoading: isAddingDoctor }] = useAddStaffMutation()

  return {
    addDoctorDialogOpen,
    setAddDoctorDialogOpen,
    isAddingDoctor,
    addDoctor,
  }
}
